import React from "react";
import "./Sea.css";
import sea from "../../img/about/sea.png";

function Sea() {
  return (
    <div className="Sea">
      <div className="Sea__mobile__img">
      <img src={sea} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="Sea__txt">
        <h1>Sea and Mountain</h1>
        <p>
          Costa Blanca's unparalleled geography offers a playground for outdoor
          enthusiasts, seamlessly transitioning from golden sandy beaches to
          rugged mountain peaks.. Whether you're seeking adrenaline-pumping
          water sports or serene hiking trails, Costa Blanca's diverse landscape
          caters to all preferences, inviting exploration and adventure at every
          turn. <br />
          <br />
          Don’t miss “Cumbre del Sol” perched on a cliff overlooking the
          Mediterranean Sea, providing breathtaking panoramic views of the
          coastline, the surrounding mountains and “Cala Moraig” beach, where
          visitors can enjoy swimming, snorkeling, and other water activities.
        </p>
      </div>
      <div className="Sea__img">
        <img src={sea} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default Sea;
